import { createSelector } from "reselect";
import { isEmpty } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => {
  const profile = state.profile.info;

  if (isEmpty(profile)) {
    return "None";
  }
  if (typeof profile.likes === "number") {
    if (profile.likes < 10 && profile.likes !== 0) {
      return `0${profile.likes}`;
    } else if (profile.likes === 0) {
      return "None";
    } else {
      return profile.likes;
    }
  } else {
    return 10;
  }
};
const getMemberLikesCount = createSelector(getData, likes => likes);
export default getMemberLikesCount;



// WEBPACK FOOTER //
// ./src/_selectors/profileSelectors/getMemberLikesCount.js